import { format } from 'date-fns';
import FormTableCalculateDisplay from '../../../components/form-table-calculate/form-table-calculate.component';
import FormTableHeaderCell from '../../../components/form-table-header-cell/form-table-header-cell.component';
import FormTableInlineDelete from '../../../components/form-table-inline-delete/form-table-inline-delete.component';
import FormTableSelect from '../../../components/form-table-select/form-table-select.component';
import FormTableTextField from '../../../components/form-table-text-field/form-table-text-field.component';

export const DEPARTMENT_INFO = {
  formTitle: "Department",
  formTitleForNew: "New Department",
  path: "/departments",
  listPage: "/departments",
}

export const DEPARTMENT_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 1,
      fieldName: "department",
      fieldItems: [
        {
          label: "Department Code",
          type: "text",
          name: "departmentCode",
          initialFocus: false,
          validationProps: {
            required: "Department Code is required"
          }
        },
        {
          label: "Department Name",
          type: "text",
          name: "departmentName",
          initialFocus: false,
          validationProps: {
            required: "Department Name is required"
          }
        }
      ]
    }
  },
  watchFields: []
}
